import React from 'react';
import StatisticItemMobile from './statisticItem';

function StatisticListMobile({
  statisticContainer,
  pseudoStatisticIds,
  statisticList,
  statisticIds,
  arr,
}) {
  return (
    <div className='betting-block-sheet' ref={statisticContainer}>
      {statisticList.length < arr.length ? (
        <div className='left-column-sheet'>
          {arr.map((item, index) => {
            return (
              <StatisticItemMobile item={statisticList[index]} key={pseudoStatisticIds[index]} />
            );
          })}
        </div>
      ) : (
        <div className='left-column-sheet'>
          {statisticList.map((item, index) => {
            return <StatisticItemMobile item={item} key={statisticIds[index]} />;
          })}
        </div>
      )}
    </div>
  );
}

export default StatisticListMobile;
